
import React from 'react';
import { createRoot } from 'react-dom/client';
import EventFinder from './EventFinder/EventFinder.jsx';

const mountNodes = Array.from(document.querySelectorAll("[data-react-component]"));
console.log("In react");
console.log(mountNodes.length);
if (mountNodes && mountNodes !== null && mountNodes.length > 0) {
  mountNodes.forEach((mountNode /*, index */) => {
    if (mountNode != null) {
      const component = mountNode.dataset?.reactComponent;
      const root = createRoot(mountNode);

      var node = null;
      if(component == "event-finder"){ 
        console.log("MOUNT NODE", mountNode);
        node = <EventFinder backgroundImage={mountNode.dataset.backgroundImage} eventType={mountNode.dataset.eventType}/>
      }
        
      root.render(<React.StrictMode>{node}</React.StrictMode>);
    }
  });
}
